import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxTrueFalseFilter} from "./ngx-true-false-filter";
import {Filter} from "../../ngx-types";

@Component({
  selector: 'app-true-false',
  templateUrl: './true-false.component.html',
  styleUrls: ['./true-false.component.scss']
})
export class TrueFalseComponent extends NgxTrueFalseFilter implements OnInit {

  @Input() label: string;
  @Input() filter: Filter;
  @Input() options: any;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  ngOnInit(): void {
  }

}
